import { Chip } from "@nestoca/ui";
import clsx from "clsx";
import { IoCheckmark } from "react-icons/io5";

import styles from "./chip-filters.module.scss";
import { ChipFilter } from "./chip-filters.types";

export interface ChipFilterItemProps {
  filter: ChipFilter;
  onClick?: (filter: ChipFilter) => void;
  activeItemValue?: ChipFilter["value"] | Record<string, boolean>;
  hasCheckmark?: boolean;
  e2ePrefix?: string;
}

export const ChipFilterItem = ({
  filter,
  onClick,
  activeItemValue,
  hasCheckmark = false,
  e2ePrefix,
}: ChipFilterItemProps) => {
  const isCheckmarkActive =
    typeof activeItemValue !== "string" && activeItemValue?.[filter.value];
  const isActive = activeItemValue === filter.value;

  const variant = hasCheckmark
    ? isCheckmarkActive
      ? "info"
      : "default"
    : "info";

  const variantStyle = hasCheckmark
    ? isCheckmarkActive
      ? "outline"
      : "solid"
    : isActive
      ? "solid"
      : "inverted";

  return (
    <Chip
      leadingIcon={hasCheckmark && isCheckmarkActive && <IoCheckmark />}
      size="large"
      variant={variant}
      variantStyle={variantStyle}
      label={filter.label}
      disabled={filter.disabled}
      className={clsx(styles["chip-filter"])}
      data-dd-action-name={filter.value}
      e2ePrefix={e2ePrefix}
      onClick={onClick ? () => onClick(filter) : undefined}
    />
  );
};
